<template>
    <el-row v-if="loading">
        <el-col>
            <h5 class="text-center mt-5">Please Wait....</h5>
        </el-col>
    </el-row>

    <el-row v-else>
        <el-col>
            <el-row class="ml-4 mr-4 pt-2" :gutter="14" v-if="count != null">
                <el-col :span="3" v-if="count.fresh > 0">
                    <div class="statistic-card">
                        <el-statistic :value="count.fresh">
                            <template #title>
                                <div style="display: inline-flex; align-items: center">
                                    Fresh Leads
                                </div>
                            </template>
                        </el-statistic>
                    </div>
                </el-col>

                <el-col :span="3" v-if="count.callback > 0">
                    <div class="statistic-card">
                        <el-statistic :value="count.callback">
                            <template #title>
                                <div style="display: inline-flex; align-items: center">
                                    Call Back
                                </div>
                            </template>
                        </el-statistic>
                    </div>
                </el-col>

                <el-col :span="3" v-if="count.reverify > 0">
                    <div class="statistic-card">
                        <el-statistic :value="count.reverify">
                            <template #title>
                                <div style="display: inline-flex; align-items: center">
                                    Reverify
                                </div>
                            </template>
                        </el-statistic>
                    </div>
                </el-col>

                <el-col :span="3" v-if="count.selfcallback > 0">
                    <div class="statistic-card">
                        <el-statistic :value="count.selfcallback">
                            <template #title>
                                <div style="display: inline-flex; align-items: center">
                                    Self Call Back
                                </div>
                            </template>
                        </el-statistic>
                    </div>
                </el-col>

                <el-col :span="3" v-if="count.cnp > 0">
                    <div class="statistic-card">
                        <el-statistic :value="count.cnp">
                            <template #title>
                                <div style="display: inline-flex; align-items: center">
                                    Call Not Picked
                                </div>
                            </template>
                        </el-statistic>
                    </div>
                </el-col>

                <el-col :span="3">
                    <div class="statistic-card">
                        <el-statistic :value="count.calledleads">
                            <template #title>
                                <div style="display: inline-flex; align-items: center">
                                    Called Leads
                                    <el-tooltip
                                        effect="dark"
                                        :content="'Day - ' + count.calledleadst + '   Older - ' + count.calledleadsp"
                                        placement="top"
                                    >
                                        <el-icon style="margin-left: 4px" :size="12">
                                            <Warning />
                                        </el-icon>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-statistic>
                    </div>
                </el-col>

                <el-col :span="3">
                    <div class="statistic-card">
                        <el-statistic :value="count.verifiedleads">
                            <template #title>
                                <div style="display: inline-flex; align-items: center">
                                    Verified Leads
                                    <el-tooltip
                                        effect="dark"
                                        :content="'Day - ' + count.verifiedleadst + '   Older - ' + count.verifiedleadsp"
                                        placement="top"
                                    >
                                        <el-icon style="margin-left: 4px" :size="12">
                                            <Warning />
                                        </el-icon>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
            </el-row>

            <el-row class="ml-4 mr-4 pt-2" :gutter="14">
                <el-col :span="3">
                    <div class="form-group">
                        <label for="seldest">Date:</label>
                        <el-input type="date" v-model="date" />
                    </div>
                </el-col>

                <el-col :span="3">
                    <div class="form-group">
                        <label for="seldest">Search:</label>
                        <el-input type="number" v-model="search" placeholder="Search Mobile" />
                    </div>
                </el-col>

                <el-col :span="3">
                    <div class="form-group">
                        <label for="seldest">Type:</label>
                        <el-select v-model="eqtype" placeholder="Select" clearable>
                            <el-option
                                v-for="item in eqtypes"
                                :key="item"
                                :label="item"
                                :value="item"
                            />
                        </el-select>
                    </div>
                </el-col>

                <el-col :span="15">
                    <div class="form-group">
                        <label for="seldest">Destinations:</label>
                        <el-select-v2
                            id="seldest"
                            v-model="destination"
                            filterable
                            :options="destinations"
                            placeholder="Select"
                            style="width: 100%"
                            clearable
                            multiple
                        >
                            <template #footer>
                                <el-button type="primary" bg size="small" @click="applydestination">
                                    Apply
                                </el-button>
                            </template>
                        </el-select-v2>
                    </div>
                </el-col>
            </el-row>
        </el-col>
    </el-row>

    <el-row v-if="!loading">
        <el-col>
            <qc-enquiry
                v-if="popupenquiryid == null && enquiry != null"
                :languages="languages"
                :enquirydet="enquiry"
                @actionevent="nextlead"
                @popupenquiry="popupenquiry"
                :user="authuser"
            ></qc-enquiry>
            <qc-enquiry
                v-if="popupenquiryid != null"
                :languages="languages"
                :enquiryid="popupenquiryid"
                @actionevent="closeenquiry"
                @closeenquiry="closeenquiry"
                @popupenquiry="popupenquiry"
                :user="authuser"
            ></qc-enquiry>
        </el-col>
    </el-row>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import {
    ElContainer, ElTooltip, ElIcon, ElStatistic, ElCheckboxGroup, ElCheckbox,
    ElAlert, ElSelectV2, ElRadioGroup, ElRadioButton, ElDialog, ElDropdownMenu,
    ElDropdown, ElDropdownItem, ElInput, ElText, ElSelect, ElOption, ElDatePicker,
    ElFormItem, ElForm, ElCol, ElRow, ElButton, ElCard, ElTag, ElDivider, ElSpace,
    ElPagination, ElCollapseItem, ElCollapse, ElAvatar, ElSkeleton
} from 'element-plus';
import AirportSearch from "./Common/AirportSearch";
import { ArrowRight, CaretBottom, CaretTop, Warning } from '@element-plus/icons-vue';

export default {
    name: "QcWorkscreen",
    props: ['user'],
    components: {
        ElContainer, Warning, ElTooltip, ElIcon, ElStatistic, ElCheckboxGroup, ElCheckbox,
        ElAlert, ElSelectV2, ElRadioGroup, ElRadioButton, ElDialog, ElDropdownMenu,
        ElDropdown, ElDropdownItem, ElInput, ElText, ElSelect, ElOption, ElDatePicker,
        ElFormItem, ElForm, ElCol, ElRow, ElButton, ElCard, ElTag, ElDivider, ElSpace,
        ElPagination, ElCollapseItem, ElCollapse, ElAvatar, ElSkeleton
    },
    data() {
        return {
            popupenquiryid: null,
            search: '',
            eqtypes: ['Auto', 'Fresh', 'CNP'],
            destination: [],
            eqtype: 'Auto',
            date: '',
            destinations: [],
            languages: [],
            id: '',
            count: null,
            loading: false,
            enquiry: null,
            authuser: null,
            currentactions: [],
            currentactiontitle: '',
            noteactions: {
                qc: ["Customer is Intrested"],
                notreachable: ["Call Not Pick", "Phone number doesn't work", "Couldn't talk to traveler this time, try again later", "Tried enough, leave the lead"],
                wontbook: ["Dupe Enquiry", "Traveler is not sure about the plan/cancelled plan", "Traveler booked with someone else", "Low Budget", "Not Intrested", "Regarding Job", "Didnt Enquiry", "Fake Enquiry", "Just Enquiry", "Test Enquiry"],
                callback: ["After 2 Hour", "In Afternoon", "In Evening", "Tomorrow Morning", "Tomorrow Afternoon", "Tomorrow Evening", "Other"],
                selfback: ["After 2 Hour", "In Afternoon", "In Evening", "Tomorrow Morning", "Tomorrow Afternoon", "Tomorrow Evening", "Other"]
            },
            tempform: {
                basicdetails: {
                    name: '',
                    mobile: '',
                    email_id: ''
                },
                note: {
                    message: ''
                },
                travellerrequirement: {
                    nights: '',
                    departure_date: '',
                    return_date: '',
                    destinations: '',
                    source: '',
                    budget: '',
                    adults: '',
                    childs: '',
                    infants: '',
                    specific_requirements: ''
                },
                addnoteaction: {
                    type: '',
                    status: '',
                    note: '',
                    reminder: ''
                }
            },
            ajax: {
                destinationsetting: {
                    ajax: {
                        url: '/api/getdestinations',
                        dataType: 'json',
                        delay: 250,
                        processResults: function (data) {
                            return {
                                results: $.map(data, function (item) {
                                    return {
                                        text: item.name,
                                        id: item.id
                                    };
                                })
                            };
                        },
                        cache: true
                    },
                    multiple: true,
                    tags: true
                },
            }
        };
    },
    mounted() {
        this.getdetails();
    },
    methods: {
        convertHMS(value) {
            const sec = parseInt(value, 10);
            let hours = Math.floor(sec / 3600);
            let minutes = Math.floor((sec - (hours * 3600)) / 60);
            let seconds = sec - (hours * 3600) - (minutes * 60);
            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            if (hours > 0) {
                return hours + ':' + minutes + ':' + seconds;
            } else if (minutes > 0) {
                return minutes + ':' + seconds;
            } else {
                return seconds;
            }
        },
        getdetails() {
            let currentObj = this;
            this.loading = true;
            axios.post('/qc/getqcworkenquiry', {
                destination: this.destination,
                date: this.date,
                eqtype: this.eqtype
            }).then(function (response) {
                currentObj.loading = false;
                currentObj.enquiry = response.data.enquiry;
                currentObj.authuser = response.data.user;
                currentObj.count = response.data.count;
                currentObj.destinations = response.data.destinations;
                currentObj.destinations.push({ value: "Other", label: "Other" });
                currentObj.languages = response.data.languages;
                if (currentObj.enquiry != null) {
                    currentObj.id = currentObj.enquiry.id;
                }
            }).catch(function (error) {
            });
        },
        searchenquiry() {
            let currentObj = this;
            this.loading = true;
            axios.post('/qc/searchqcenquiry?key=' + this.search).then(function (response) {
                currentObj.loading = false;
                if (response.data.status) {
                    currentObj.popupenquiryid = response.data.id;
                } else {
                    currentObj.popupenquiryid = null;
                }
            }).catch(function (error) {
                currentObj.loading = false;
            });
        },
        nextlead() {
            this.id = "";
            this.getdetails();
        },
        popupenquiry(enquiry) {
            this.popupenquiryid = enquiry;
        },
        closeenquiry() {
            this.popupenquiryid = null;
        },
        applydestination() {
            if (this.destination == null) {
                this.destination = [];
            }
            this.id = "";
            this.getdetails();
        }
    },
    watch: {
        'eqtype'(newvalue) {
            this.getdetails();
        },
        'date'(newvalue) {
            if (newvalue == null) {
                this.date = "";
            }
            this.id = "";
            this.getdetails();
        },
        'search'(newvalue) {
            if (this.search.toString().length == 10) {
                this.searchenquiry();
            } else {
                this.popupenquiryid = null;
            }
        }
    }
};
</script>

<style scoped>
:global(h2#card-usage ~ .example .example-showcase) {
    background-color: var(--el-fill-color) !important;
}

.el-statistic {
    --el-statistic-content-font-size: 28px;
}

.statistic-card {
    height: 100%;
    padding: 5px 20px;
    border-radius: 4px;
    background-color: var(--el-bg-color-overlay);
}

.statistic-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-size: 12px;
    color: var(--el-text-color-regular);
    margin-top: 16px;
}

.statistic-footer .footer-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.statistic-footer .footer-item span:last-child {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
}

.green {
    color: var(--el-color-success);
}

.red {
    color: var(--el-color-error);
}
</style>